import React, { useEffect, useRef, useState } from "react";
import AvatarArrow from "../../../assets/icons/AvatarArrow";
import {
  Container,
  Avatar,
  DropContent,
  UserClick,
  UserInfo,
  HeadInfo,
  UserName,
  Rank,
  HorizontalLine,
  UList,
  ListItem,
} from "./styles";
import { useOutsideDrop } from "../../../hooks/useOutsideDrop";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import UserModal from "../AlertModals/UserModal";
import ChangePasswordModal from "../AlertModals/ChangePasswordModal";

import { getUser } from "../../../state/users/selectors";
import { useDispatch } from "react-redux";
import { signOut, updateAvatar } from "../../../state/auth/actions";
import { useVerifyToken } from "../../../hooks/useVerifyToken";
import { toastAlert } from "../../Toastify/index";
import api from "../../../services/api";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { clearStats } from "../../../state/userStats/actions";
import { clearAllDashboardData } from "../../../state/dashboard/actions";

const User = ({ style = {} }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const clearDropdown = () => setOpen(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => getUser(state));

  const [userModalOpen, setUserModalOpen] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  useOutsideDrop(wrapperRef, clearDropdown);

  const { promiseInProgress: fetchingAvatar } = usePromiseTracker({
    area: "fetchAvatar",
  });

  useVerifyToken();

  const [picture, setPicture] = useState(user?.avatarURL);

  async function fetchPicture() {
    try {
      await trackPromise(
        api.get(`/users/picture/`).then((res) => setPicture(res.data.url)),
        "fetchAvatar"
      );
    } catch (err) {
      toastAlert({
        msg: "Houve um erro ao carregar a imagem do usuário",
        isError: true,
      });
    }
  }

  const handleDeletePicture = async (id) => {
    const response = await api.delete(`users/profile/picture/delete/${id}`);
    setPicture(response.data.url);
    dispatch(updateAvatar({ url: response.data.url }));
  };

  useEffect(() => {
    let isMounted = true;

    if (!user && isMounted) {
      fetchPicture();
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return user && !fetchingAvatar ? (
    <Container ref={wrapperRef} style={style}>
      <Avatar src={picture} />
      <UserClick open={open} onClick={() => setOpen((prev) => !prev)}>
        <span>{user?.username.split(" ")[0]}</span>
        <AvatarArrow />
      </UserClick>
      <DropContent open={open}>
        <UserInfo>
          <Avatar src={picture} UserInfo />
          <HeadInfo>
            <UserName>{user?.username}</UserName>
            <Rank>{user?.rank}</Rank>
          </HeadInfo>
        </UserInfo>
        <HorizontalLine />
        <UList>
          <ListItem onClick={() => setUserModalOpen(true)}>
            Editar Perfil
          </ListItem>
          <ListItem
            onClick={() => {
              dispatch(signOut());
              dispatch(clearStats());
              dispatch(clearAllDashboardData());
              history.push("/login");
            }}
          >
            Fazer logout
          </ListItem>
        </UList>
      </DropContent>
      <UserModal
        user={user}
        isOpen={userModalOpen}
        onClose={() => setUserModalOpen(false)}
        selector="#root"
        className="nodrag"
        usePicture={[picture, setPicture]}
        handleDeletePicture={handleDeletePicture}
        modalChange={() => {
          setPasswordModalOpen(true);
          setUserModalOpen(false);
        }}
      />
      <ChangePasswordModal
        isOpen={passwordModalOpen}
        onClose={() => {
          setPasswordModalOpen(false);
          setUserModalOpen(true);
        }}
        selector="#root"
        className="nodrag"
      />
    </Container>
  ) : null;
};

export default User;
